import { useCallback } from "react";

import { IPhoneNumberData, PhoneNumberHelper } from "@/ContactDirectory/Helpers/PhoneNumberHelper";

export const usePhoneNumberFormatter = (geoCountryId: string, geoStateId: string = null) : ((number: IPhoneNumberData) => string) => useCallback(
    (number: IPhoneNumberData): string => PhoneNumberHelper
        .format(
            number?.number,
            number?.countryId ?? geoCountryId,
            cacheStore.GetGeographicsStatesForCountryId(number?.countryId ?? geoCountryId)?.some(p => p.Id === geoStateId) ? geoStateId : null,
            number?.extension
        ),
    [geoCountryId, geoStateId]
);
